import {Display, Layout, Panel} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import {observer} from 'mobx-react';
import bookedSvg from '../../img/booked.svg';

const ScheduleInterviewCompleteContainer = observer(({uiState}) => {
  const {interviewInvite} = uiState;
  const {logoUrl, companyName, interviewSchedule} = interviewInvite;

  return (
    <div>
      <Panel className='schedule-interview-header'>
        <div className='flex justify-center h1 medium py1'>
          {logoUrl ? <img alt='company logo' className='align-top CompanyLogo-img' style={{maxHeight: '35px'}} src={logoUrl}/> :
            companyName}
        </div>
      </Panel>
      <Display documentTitle={interviewSchedule.calendarEventName}/>
      <Layout>
        <div className='mt4 mb3 center' style={{fontSize: '44px'}}>
          <FormattedMessage id="recruiting.schedule_interview.complete.You're all set!"/>
        </div>
        <div className='center mb1'>
          <FormattedMessage id='recruiting.schedule_interview.complete.Your interview has been scheduled.'/>
        </div>
        <div className='center mb4'>
          <FormattedMessage id="recruiting.schedule_interview.complete.You'll receive a calendar invite with all the details shortly."/>
        </div>
        <div className='mx-auto max-w-sm'>
          <img src={bookedSvg} alt='confirmation' className='full-width' />
        </div>
      </Layout>
    </div>
  );
});

export default ScheduleInterviewCompleteContainer;
